import { API } from '../../utils/authFetch';

export interface SendSettings {
    campaignId: string;
    senderProvider: 'outlook' | 'spacemail';
    senderAccountLimit: number;
    outlookPerSenderDailyLimit: number;
    batchLimit: number;
}

function storageKey(api = API): string {
    // Store preferences only, never the authentication token or an approval.
    const auth = JSON.parse(localStorage.getItem('acq_auth') || '{}');
    const identity = JSON.stringify([auth.role || '', auth.regions || [], auth.label || '']);
    return `acq_send_settings_v1:${api}:${identity}`;
}

function integer(value: unknown, max: number): value is number {
    return typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= max;
}

export function readSendSettings(previousApi = process.env.REACT_APP_MIGRATED_FROM_API, currentApi = API): Partial<SendSettings> {
    try {
        const current = localStorage.getItem(storageKey(currentApi));
        const migrated = !current && previousApi === 'https://acquisition-engine-production.up.railway.app'
            && ['127.0.0.1', 'localhost'].includes(new URL(currentApi).hostname)
            ? localStorage.getItem(storageKey(previousApi)) : null;
        const saved = JSON.parse(current || migrated || '{}');
        if (!saved || typeof saved !== 'object') return {};
        const validated = {
            campaignId: typeof saved.campaignId === 'string' ? saved.campaignId : undefined,
            senderProvider: ['outlook', 'spacemail'].includes(saved.senderProvider) ? saved.senderProvider : undefined,
            senderAccountLimit: integer(saved.senderAccountLimit, 100_000) ? saved.senderAccountLimit : undefined,
            outlookPerSenderDailyLimit: integer(saved.outlookPerSenderDailyLimit, 100) ? saved.outlookPerSenderDailyLimit : undefined,
            batchLimit: integer(saved.batchLimit, 100_000) ? saved.batchLimit : undefined,
        };
        // Copy preferences only after an actual local data migration. Never
        // import tokens, review attestations, or an instruction to send.
        if (migrated) localStorage.setItem(storageKey(currentApi), JSON.stringify(validated));
        return validated;
    } catch { return {}; }
}

export function saveSendSettings(settings: SendSettings): void {
    try { localStorage.setItem(storageKey(), JSON.stringify(settings)); }
    catch { /* Storage restrictions must not stop the operator using the page. */ }
}
